export default function MethodDivider() {
  return (
    <div className="flex items-center">
      <div className="border-taupe-light-75 flex-grow border-t border-dashed"></div>
      <span className="text-brown-dark flex-shrink px-4 text-base font-semibold">or</span>
      <div className="border-taupe-light-75 flex-grow border-t border-dashed"></div>
    </div>
  );
}
